import { render, staticRenderFns } from "./inspection-info.vue?vue&type=template&id=2304f1d7&scoped=true&"
import script from "./inspection-info.vue?vue&type=script&lang=js&"
export * from "./inspection-info.vue?vue&type=script&lang=js&"
import style0 from "./inspection-info.vue?vue&type=style&index=0&id=2304f1d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304f1d7",
  null
  
)

export default component.exports